import { DecoratorBlockNode } from "@lexical/react/LexicalDecoratorBlockNode";
import { $getRoot } from "lexical";
import { headlessDecorate } from "./headless-decorate";

import type { SerializedDecoratorBlockNode } from "@lexical/react/LexicalDecoratorBlockNode";
import type { LexicalEditor, LexicalNode, NodeKey, Spread } from "lexical";

type SerializedPaperColorNode = Spread<
  {
    hex?: string;
    type: "paper-color";
    version: number;
  },
  SerializedDecoratorBlockNode
>;

export class PaperColorNode extends DecoratorBlockNode {
  __hex?: string;

  decorate(editor: LexicalEditor): React.JSX.Element {
    const root = editor.getRootElement();
    if (root) root.style.backgroundColor = this.__hex ?? "";
    return headlessDecorate();
  }

  static getType(): string {
    return "paper-color";
  }

  static clone(node: PaperColorNode): PaperColorNode {
    return new this(node.__hex, node.__key);
  }

  constructor(hex?: string, key?: NodeKey) {
    super(undefined, key);
    this.__hex = hex;
  }

  isSelected(): boolean {
    return false;
  }

  createDOM(): HTMLElement {
    return document.createElement("span");
  }

  setNewHex(hex?: string): void {
    const writable = this.getWritable();
    writable.__hex = hex;
  }

  static importJSON(serializedNode: SerializedPaperColorNode): PaperColorNode {
    return new this(serializedNode.hex);
  }

  exportJSON(): SerializedPaperColorNode {
    return {
      hex: this.__hex,
      format: "",
      type: "paper-color",
      version: 1,
    };
  }
}

export function $isPaperColorNode(node: LexicalNode): node is PaperColorNode {
  return node instanceof PaperColorNode;
}

export function $createPaperColorNode(hex?: string): PaperColorNode {
  return new PaperColorNode(hex);
}

export function $getPaperColorNode(): PaperColorNode | undefined {
  const root = $getRoot();

  const children = root.getChildren();
  for (const child of children) {
    if ($isPaperColorNode(child)) {
      return child;
    }
  }
  return undefined;
}
